export default "__VITE_ASSET__ghEceeof__"